import {ICompany, ICompanySyncstep} from "../../index";
import {_} from 'lodash';
import {Permission} from "../../constants/Permission";

export namespace nsSyncStatus {
    export function isExecuteSyncstepEnabled(company: ICompany, css: ICompanySyncstep): boolean {
        const a = company.lastsyncstep?.halted
        const b = company.pausedeltasync == true
        if (a || b) {
            return false
        }

        const companySyncsteps = _.sortBy(company.syncsteps ?? [], (s: ICompanySyncstep) => s.order)
        const lastSyncstepIndex = companySyncsteps.findIndex((s: ICompanySyncstep) => s.syncstep.name == company.lastsyncstep?.syncstepname)
        const currentSyncstepIndex = companySyncsteps.findIndex((s: ICompanySyncstep) => s.syncstep.name == css.syncstep.name)
        const isEverySyncstepExecuted = lastSyncstepIndex == companySyncsteps.length - 1
        if (isEverySyncstepExecuted) {
            const isFirstStep = currentSyncstepIndex == 0
            return isFirstStep
        } else {
            const isNextStep = currentSyncstepIndex == lastSyncstepIndex + 1
            return isNextStep
        }
    }

    export function isExecuteSyncstepAvailable(company: ICompany, css: ICompanySyncstep, permission: Permission): boolean {
        const a = permission >= Permission.CompanyAdmin
        const b = company.deltasync
        const c = !css.syncstep.name.startsWith('Import AD Results')
        const d = !css.syncstep.name.startsWith('ImportHrFuture')
        return a && b && c && d
    }
}